import shared_address_default from './DefaultAddress'
import shared_contact_default from './DefaultContact'


export default {
  id: null,
  name: '',
  document: '',
  cnpj_client: false,
  client_is: 'cpf',
  state_inscription: '',
  corporate_name: null,
  fantasyName: null,
  fantasy_name: null,

  address:{
    ...shared_address_default
  },

  main_address:{
    ...shared_address_default
  },

  shipping_addresses:[
    {...shared_address_default}
  ],
  contacts:[
    {...shared_contact_default}
  ],

  client_credit: {
    status_id: 1,
    limit: null,
    blocking_time: null
  }
}